/* ==========================================================================
   assets/upgrade-colours.js -- window.UpgradeColours.hex(name)

   A swatch colour for every colour name the catalogue sells (the list in
   04-OPERATIONS/ecommerce/colours/colour-list.json, 27 Sep 2026). Each value
   is an approximate, representative shade for a small dot beside the name --
   never a claim about the exact finish. The name is always shown or
   announced with the dot: colour is never the only thing that tells a
   customer which option they picked.

     UpgradeColours.hex('Natural Titanium')  -> '#b9b1a5'
     UpgradeColours.hex('natural titanium')  -> the same (case-insensitive)
     UpgradeColours.hex('NATURALTITANIUM')   -> the same (a SKU colour code)
     UpgradeColours.hex('Marble Grey')       -> the same as 'Marble Gray'
     UpgradeColours.hex('Something new')     -> null: draw a neutral outlined
                                                dot and keep the name.

   One name, one dot: "Blue" on an iPhone 13 and "Blue" on an iPhone 15 are
   different shades in life and the same swatch here.

   Loaded with defer from layout/theme.liquid, in <head> before the price map
   (the Arabic-ready copy loads it right after upgrade-i18n.js). Colour
   variants, ported 27 Sep 2026: comment corrected for both themes.
   No dependencies, no strings (a colour name is data, not copy).
   ========================================================================== */
(function () {
  'use strict';
  if (window.UpgradeColours) { return; }

  /* Keyed by the lookup form: lower case, letters and digits only. */
  var HEX = {
    midnight: '#232a31',
    starlight: '#ede6da',
    blue: '#5b7a99',
    pink: '#f0c9cf',
    green: '#6f8a72',
    red: '#b1262d',
    graphite: '#545250',
    gold: '#eddcbd',
    silver: '#e1e2e3',
    sierrablue: '#9bb3cc',
    alpinegreen: '#56695a',
    purple: '#cbc0da',
    yellow: '#f2df8c',
    spaceblack: '#3a3937',
    deeppurple: '#584e63',
    black: '#27292b',
    blacktitanium: '#3b3c3e',
    whitetitanium: '#e8e6e1',
    bluetitanium: '#3f4a5a',
    naturaltitanium: '#b9b1a5',
    white: '#f4f4f1',
    teal: '#8fbdb7',
    ultramarine: '#7c8ee4',
    deserttitanium: '#c3a58a',
    mistblue: '#aabed3',
    lavender: '#cdbde0',
    sage: '#b7c3a3',
    cosmicorange: '#dd7a3a',
    deepblue: '#34425e',
    phantomblack: '#2c2c2f',
    cream: '#eee6d5',
    lime: '#d8e19b',
    skyblue: '#a9c8e3',
    cobaltviolet: '#574d8c',
    marblegray: '#bcbcbe',
    onyxblack: '#2a2b2d',
    amberyellow: '#ecd07a',
    titaniumblack: '#2f3032',
    titaniumgray: '#8c8a86',
    titaniumviolet: '#736a85',
    titaniumyellow: '#e2d4a3',
    navy: '#2c3653',
    icyblue: '#c4d6e8',
    mint: '#bfdfcf',
    silvershadow: '#b3b6b9',
    coralred: '#dc6b60',
    pinkgold: '#eac9b7',
    titaniumsilverblue: '#9fadbf',
    titaniumwhitesilver: '#e2e3e1',
    titaniumjetblack: '#1f2022',
    /* Not on the list, but in the AX item master (Space Gray / Space Grey). */
    spacegray: '#6e6f71'
  };

  function lookupKey(name) {
    return name.toLowerCase().replace(/grey/g, 'gray').replace(/[^a-z0-9]/g, '');
  }

  function hex(name) {
    if (typeof name !== 'string') { return null; }
    var k = lookupKey(name);
    return (k && Object.prototype.hasOwnProperty.call(HEX, k)) ? HEX[k] : null;
  }

  window.UpgradeColours = { hex: hex };
})();
